<div>
  <span>
    {{ formatValue }}
    <span [style.color]="getFillColor()" [class.bold]="percentageChange !== null">
      {{formattedChange}}
    </span>
  </span>
  <span *ngIf="percentageChange > 0">
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.00002 19H21C21.372 19 21.713 18.793 21.886 18.464C22.059 18.135 22.034 17.737 21.823 17.431L12.823 4.43101C12.45 3.89201 11.552 3.89201 11.178 4.43101L2.17802 17.431C1.96602 17.737 1.94202 18.135 2.11502 18.464C2.28702 18.793 2.62802 19 3.00002 19Z"
        [attr.fill]="getFillColor()" />
    </svg>
  </span>
  <span *ngIf="percentageChange < 0">
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.1781 19.569C11.3641 19.839 11.6721 20 12.0001 20C12.3281 20 12.6361 19.839 12.8221 19.569L21.8221 6.569C22.0341 6.263 22.0581 5.865 21.8851 5.536C21.7131 5.207 21.3721 5 21.0001 5H3.00006C2.62806 5 2.28706 5.207 2.11406 5.536C1.94106 5.865 1.96606 6.263 2.17806 6.569L11.1781 19.569Z"
        [attr.fill]="getFillColor()" />
    </svg>
  </span>
</div>